module.exports = __webpack_public_path__ + "img/sherrer-paineis-4.7fe41420.jpeg";